import { AppDashboardOptions, DefaultMeta, DefaultBody, AppUppy } from "common";
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import { DEFAULT_ALLOWED_FILE_EXTENSIONS } from "common";

export const getUppyInstance = (): AppUppy => {
  const uppy = new Uppy<DefaultMeta, DefaultBody>({
    debug: false,
    autoProceed: false,
    restrictions: {
      maxFileSize: 20971520, // 20MB
      maxNumberOfFiles: 10,
      allowedFileTypes: DEFAULT_ALLOWED_FILE_EXTENSIONS,
    },
    locale: {
      strings: {},
      pluralize: (n: number) => n === 1 ? 0 : 1,
    },
  });

  return uppy;
};

export const useUppyXHRUploadPlugin = (
  uppy: AppUppy,
  endpoint: string,
  accessToken: string
): void => {
  uppy.use(XHRUpload, {
    endpoint,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const getUppyDashboardOptions = (): AppDashboardOptions => {
  return {
    id: "Dashboard",
    height: 312,
    width: 480,
    plugins: [],
    hideUploadButton: true,
    hideRetryButton: true,
    hidePauseResumeButton: true,
    proudlyDisplayPoweredByUppy: false,
  };
};
